import React from "react";
import Header from "../../../components/Header";
import FooterTwo from "../../../components/Footer/FooterTwo";
import ScrollToTop from "../../../components/ScrollTop";
import MonthlyMagazineData from "../../../data/monthly-magazine.json";
import "./MonthlyMagazine.scss"; // (Create this for custom styling)

const MonthlyMagazine = () => {
  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        topbarEnable="enable"
      />
      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <div
            className="magazine-list-wrapper"
            style={{ paddingBottom: "180px" }}
          >
            <h2 className="magazine-list-title">
              Jnani Junction - Monthly Current Affairs Magazine
            </h2>
            <div className="magazine-grid">
              {MonthlyMagazineData.map((magazine) => (
                <a
                  key={magazine.id}
                  href={magazine.downloadLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="magazine-card"
                >
                  <div className="magazine-card-header">
                    <h3>{magazine.title}</h3>
                  </div>
                  <div className="magazine-card-body">
                    <div className="magazine-card-content">
                      <h4 className="magazine-title">{magazine.month}</h4>
                      <ul className="magazine-details">
                        <li>📝 300+ Current Affairs MCQs</li>
                        
                        <li>📥 Click to Download</li>
                      </ul>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <ScrollToTop />
        </div>
      </div>
      <FooterTwo />
    </>
  );
};

export default MonthlyMagazine;
